import { render, staticRenderFns } from "./EditExpirationDateDialog.vue?vue&type=template&id=30156d28&"
import script from "./EditExpirationDateDialog.vue?vue&type=script&lang=js&"
export * from "./EditExpirationDateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports